var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flat-color-icons:disclaimer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35 22H40V13.5C40 12.1 38.9 11 37.5 11C36.1 11 35 12.1 35 13.5V22ZM28 22H33V7.5C33 6.1 31.9 5 30.5 5C29.1 5 28 6.1 28 7.5V22ZM21 22H26V5.5C26 4.1 24.9 3 23.5 3C22.1 3 21 4.1 21 5.5V22ZM14 22H19V8.5C19 7.1 17.9 6 16.5 6C15.1 6 14 7.1 14 8.5V22ZM15.9 43L20.9 38L10.9 28C9.5 26.6 7.3 26.6 6 28C4.6 29.4 4.6 31.6 6 32.9L15.9 43Z",
    fill: "#FFCC80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19 21C19 21.6 19.4 22 20 22C20.6 22 21 21.6 21 21H26C26 21.6 26.4 22 27 22C27.6 22 28 21.6 28 21H33C33 21.6 33.4 22 34 22C34.6 22 35 21.6 35 21H40V37C40 41.4 36.4 45 32 45H20.8C17.1 45 14 42 14 38.2V21H19Z",
    fill: "#FFCC80"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.ec234351f820ee3b12fac4f2149f5015.svg";
export { ForwardRef as ReactComponent };